export type Theme = {
  name: string;
  bg: string;
  surface: string;
  fg: string;
  fgMute: string;
  border: string;
  accent: string;
  accentSoft: string;
  accentBorder: string;
  accentFg: string;
  onAccent: string;
  danger: string;
  radius: number;
  font: string;
  mono: string;
};

export const graphite: Theme = {
  name: "Graphite",
  bg: "#fbfbfc",
  surface: "#f4f4f6",
  fg: "#0b0d10",
  fgMute: "#5c626e",
  border: "#e6e7eb",
  accent: "#4fa7b5",
  accentSoft: "rgba(79, 167, 181, 0.09)",
  accentBorder: "rgba(79, 167, 181, 0.30)",
  accentFg: "#4fa7b5",
  onAccent: "#ffffff",
  danger: "#d14c4c",
  radius: 8,
  font: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  mono: "'JetBrains Mono', ui-monospace, monospace",
};
